// import Side from '../side/Side'
// import './account.css'
// import React, { useEffect, useState } from 'react'
// import { useContext } from 'react';
// import { AppContext } from '../../App';
// import { json, useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// const Account = () => {
//     const {route ,setLoader ,imgRoute}=useContext(AppContext)
//     const [user,setUser]=useState({})
//     const [det,setDet]=useState({})
//     const [prod,setProd]=useState({})


//     useEffect(()=>{
//         fetch(`${route}/acc/getMe`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//             console.log(data)

//         setUser(data.user)
//     if(data.user.details){
//         setDet(data.user.details)
//     }
//     if(data.user.product){
//         setProd(data.user.product)
//     }
//         })
//     },[])
//   return (
//     <div className="account">
//         <div className="container">
//         <h1>بيانات الحساب</h1>
//         <div className="the-data">
//             {/* <div>{user.name} : الاسم</div>
//             <div>{user.father_name} : اسم الأب</div>
//             <div>{user.mother_name} : اسم الأم</div>
//             <div>{user.nickname} : النسبة</div>
//             <div>{user.id} : المكتب الخاص</div> */}
//              <div>{user.name} : الاسم</div>
//             <div>{user.father_name} : اسم الاب</div>
//             <div>{user.nickname} : النسبة</div>
//             <div>{user.mother_name} : اسم الام</div>
//             <div>{user.id} : المكتب الخاص</div>
//             <div>{det.phone} : رقم الهاتف</div>
//             <div>{user.email} : الايميل</div>
//             <div>{det.address_city} : مدينة السكن</div>
//             <div>{det.address_country} : بلد السكن</div>
//             <div>{det.address_street} : شارع السكن</div>
//             <div>{det.amana} : الامانة</div>
//             <div>{det.birth_city} : تاريخ الميلاد</div>
//             <div>{det.birth_country} : بلد المنشأ</div>
//             <div>{det.birth_street} : شارع المنشأ</div>
//             <div>{det.birthday} : تاريخ الميلاد</div>
//             <div>{det.created_at} : تم الانشاء</div>
//             <div>{det.gender} : النوع</div>
//             <div>{det.inheritor} : الوريث</div>
//             <div>{det.man7_history} : تاريخ المنح</div>
//             <div>{det.national_number} : الرقم القومي</div>
//             <div>{det.qid} : القيد</div>
//             <div>{det.shipping_city} : مدينة الشحن</div>
//             <div>{det.shipping_country} : بلد الشحن</div>
//             <div>{det.shipping_street} : شارع الشحن </div>
//             <div>{prod.title} : المنتج المطلوب</div>
//             {/* {prod ?            <div className="img">
//                 صورة المنتج
//                 {prod.images.map((one,index)=>{
//                     if(index === 0){
//                         return(
//                         <img src={`${imgRoute}/${one.image}`} />
//                         )
//                     }
//                 })}
//             </div> :null}
//   */}
//             <div className='img'>
//             صورة الهوية الامامية
//             <img src={`${imgRoute}/${det.identity_front}`} alt="" />
//             </div>
//             <div className='img'>
// صورة الهوية الخلفية
//             <img src={`${imgRoute}/${det.identity_back}`} alt="" />
//             </div>
//             <div className='img'>
// صورة الشهاده الصحية
//             <img src={`${imgRoute}/${det.healthDoc}`} alt="" />
//             </div>
//         </div>
//         </div>
//         <Side />
//     </div>
//   )
// }

// export default Account
import "./account.scss";
import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../App";
import { toast } from "react-toastify";
import Side from "../side/Side";

const Skeleton = ({ height = 16 }) => (
  <div className="skeleton" style={{ height }} />
);

const InfoRow = ({ label, value, loading }) => (
  <div className="info-row">
    <span>{label}</span>
    {loading ? <Skeleton /> : <strong>{value || "-"}</strong>}
  </div>
);

const Account = () => {
  const { route, imgRoute } = useContext(AppContext);
  const [user, setUser] = useState({});
  const [det, setDet] = useState({});
  const [prod, setProd] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${route}/acc/getMe`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.error) {
          toast.error("انتهت الجلسة");
          return;
        }
        setUser(data.user || {});
        setDet(data.user?.details || {});
        setProd(data.user?.product || {});
        setLoading(false);
      });
  }, []);

  return (
    <div className="account-page">
      <div className="account-container">
        <h2>بيانات الحساب</h2>

        {/* ===== Info ===== */}
        <div className="info-card">
          <InfoRow label="الاسم" value={user.name} loading={loading} />
          <InfoRow label="اسم الأب" value={user.father_name} loading={loading} />
          <InfoRow label="اسم الأم" value={user.mother_name} loading={loading} />
          <InfoRow label="النسبة" value={user.nickname} loading={loading} />
          <InfoRow label="كود المكتب" value={user.id} loading={loading} />
          <InfoRow label="رقم الهاتف" value={det.phone} loading={loading} />
          <InfoRow label="الإيميل" value={user.email} loading={loading} />
          <InfoRow label="النوع" value={det.gender} loading={loading} />
          <InfoRow label="الوريث" value={det.inheritor} loading={loading} />
          <InfoRow label="الرقم القومي" value={det.national_number} loading={loading} />
          <InfoRow label="القيد" value={det.qid} loading={loading} />
          <InfoRow label="الأمانة" value={det.amana} loading={loading} />
          <InfoRow label="تاريخ الإنشاء" value={det.created_at} loading={loading} />
          <InfoRow label="المنتج" value={prod.title} loading={loading} />
        </div>

        {/* ===== Images ===== */}
        <div className="images-card">
          <div className="img-box">
            <span>الهوية الأمامية</span>
            {loading ? <Skeleton height={100} /> : <img src={`${imgRoute}/${det.identity_front}`} />}
          </div>
          <div className="img-box">
            <span>الهوية الخلفية</span>
            {loading ? <Skeleton height={100} /> : <img src={`${imgRoute}/${det.identity_back}`} />}
          </div>
          <div className="img-box">
            <span>الشهادة الصحية</span>
            {loading ? <Skeleton height={100} /> : <img src={`${imgRoute}/${det.healthDoc}`} />}
          </div>
        </div>
      </div>

      <Side />
    </div>
  );
};

export default Account;
